<section
	*ngIf="isMobile"
	id="checkout-success-screen-header-mobile"
	class="mobileSingleHeader"
>
	<img class="user-avatar dropdown-toggle" src="{{ userImage }}" />
	<span class="pageTitle">{{ 'USERMENU.MEMBERSHIP' | translate }}</span>
	<fa-icon icon="times" class="times" routerLink="/account/premium"></fa-icon>
</section>

<zk-checkout-success
	id="checkout-success-screen"
	[cart]="handleCart()"
	[labelBoletoDownloadButton]="'PAYMENT_SUCCESS.BOLETO_BUTTON' | translate"
	[labelSumaryTotal]="'CHECKOUT.TOTAL' | translate"
	[messageGeneratedBoleto]="'PAYMENT_SUCCESS.GENERATED_BOLETO' | translate"
	[messageSuccessfulPayment]="'PAYMENT_SUCCESS.MESSAGE' | translate"
	[titleNextSteps]="'CHECKOUT.NEXT_STEPS' | translate"
	[titleSuccessful]="'CHECKOUT.SUCCESS' | translate"
	[titleSumary]="'CHECKOUT.PAYMENT_SUMMARY' | translate"
>
	<app-checkout-items [cart]="cart" nextStepsBelow></app-checkout-items>
</zk-checkout-success>
